import React, { FC } from 'react';
import { Trans } from 'react-i18next';
import classNames from 'classnames';
import { Button, Card, CardHeader, Divider } from '@material-ui/core';
import { withStyles, WithStyles } from '@material-ui/core/styles';

import { S3Object, S3ObjectInput } from 'api';
import { Photo as PhotoWidget } from 'features/content/widgets';

import { RemoveTypes } from '../../types';
import styles from './styles';

interface IProps extends WithStyles<typeof styles> {
  photo: S3Object | S3ObjectInput;
  onRemove: (type: RemoveTypes) => () => void;
}

const Photo: FC<IProps> = ({ classes, onRemove, photo }) => (
  <div className={classNames(classes.placeholder, classes.photoSpacer)}>
    <Card elevation={0} className={classes.card} square>
      <Divider />
      <CardHeader
        className={classes.cardHeader}
        action={
          onRemove && (
            <Button className={classes.button} onClick={onRemove(RemoveTypes.photo)}>
              <Trans i18nKey="posting:removePhoto" />
            </Button>
          )
        }
      />
      <div className={classes.photo}>
        <PhotoWidget photo={photo} />
      </div>
    </Card>
  </div>
);

export default withStyles(styles)(Photo);
